import React, { Component } from 'react'
import { Row, message, Button, Modal, Spin,DatePicker } from "antd"
import closeIcon from "app/styles/images/sp/close.svg"
import { observer } from 'mobx-react'
import MaterialModal from "app/components/normal/MaterialModal"
import MaterialFormItem from "app/components/normal/MaterialFormItem/MaterialFormItem"
import "./Index.scss"
const { RangePicker } = DatePicker
@observer
export default class exportGroupModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      exportModalShowed: false,
      downLoadText: '',
      startDate:'',//20240428
      endDate:'',//20240428
    }
  }
  componentDidMount() {
    const { exportConnectWebsocket } = this.props.store
    exportConnectWebsocket()
  }
  componentWillUnmount() {
    const { closeExportWebsocket } = this.props.store
    closeExportWebsocket()
  }
  handleBatchExport = () => {
    const { startDate, endDate } = this.state
    // console.log(startDate,endDate)
    const {  getReportImageUrlDate } = this.props.store
    if (!startDate || !endDate) {
      message.error('请选择需要导出的时间段')
      return
    }
    
    this.setState({
      exportModalShowed: true,
      downLoadText: '正在导出中，请稍等。。。'
    })
    getReportImageUrlDate(startDate,endDate).then(
      (res) => {
       
         // const exportDataUrl = res.url
        const {  exportModalShowed } = this.props.store
        // console.log(exportModalShowed)
        this.setState({
          exportModalShowed: exportModalShowed
        })
         // const { onClose } = this.props
        // onClose()
        // if (document.getElementById("export-a-tag"))
        //   document.getElementById("export-a-tag").outerHTML = ""
        // let a = document.createElement("iframe")
        // a.setAttribute("src", exportDataUrl)
        // a.setAttribute("id", "export-a-tag")
        // a.setAttribute("style", "display:none")
        // //防止反复添加
        // if (!document.getElementById("export-a-tag"))
        //   document.body.appendChild(a)
      },
      (err) => {
        message.error("导出失败，请您重试！")
        this.setState({
          exportModalShowed: false,
        })
      }
    )
  }

  onChange=(date, dateString)=>  {
    // console.log(date, dateString)
    this.setState({
      startDate: dateString[0].replace(/-/g, ""),
      endDate: dateString[1].replace(/-/g, "")
    }, () => {
      this.forceUpdate()
      // console.log(this.state) // 在状态更新后打印状态值
    })

  }
  disabledDate=(current)=>  {
    return current && current.valueOf() > Date.now()
  }

  render() {
    const { onClose } = this.props
    return (
      <MaterialModal
        title={"组数据点图导出"}
        visible
        width={700}
        footer={(
          <Row type="flex" justify="center" align="middle">
            <Button
              type="primary"
              size="default"
              className="export-btn"
              onClick={this.handleBatchExport}
            >
              导出点图
            </Button>
          </Row>
        )
        }
      >
        <img
          className="pgx-modal-close"
          src={closeIcon}
          alt="关闭对话框"
          onClick={onClose}
        />
        <Row type='flex' justify='start' align='middle' 
          className='subtitle' 
          style={{height:'200px',marginLeft:'150px'}}
        >
          <i></i>
          <MaterialFormItem
            labelWidth={47}
            labelText="选择日期："
            className="group-name"
          >
            <Row type="flex" justify="start" align='middle'>
                <RangePicker 
                  disabledDate={this.disabledDate} 
                  onChange={this.onChange} 
                />
            </Row>
          </MaterialFormItem>
        </Row>
        <Modal
          className="statistics-export-modal"
          width={230}
          visible={this.state.exportModalShowed}
          footer={null}
        >
          <div className="export-loading"><Spin size="large" /></div>
          <div className="export-tips">{ this.state.downLoadText }</div>
        </Modal>
      </MaterialModal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/pgs/report/ExportGroupDotplot.js